import { makeRPCPost } from '../RpcAPI/RpcAPI';
import { parseRawLoyalty, parseRawSamples } from '~api/SamplesAPI/utils';
import { diContainer } from '~setup/diContainer';
import { serviceNames } from '~setup/OffersService';
import { getGlobalHeaders } from '~api/common/getHeaders';
import { ILoyalty } from '~domain/entities/Loyalty/ILoyalty';

export interface ISampleParams {
    [key: string]: string[];
}

export const setSamples = async (samplesObject: ISampleParams) => {
    const body = Object.entries(samplesObject).reduce(
        (acc, [key, value]) => [
            ...acc,
            {
                method: 'offers.apply',
                params: [
                    {
                        offer_code: key,
                        benefits: { ChoiceOfSkus: { choices: [...value] } }
                    }
                ]
            }
        ],
        []
    );

    return makeRPCPost(body);
};

export const removeOfferByCode = async (offerId: string) => {
    const body = [
        {
            method: 'offer.removeOfferByCode',
            params: [
                {
                    offer_code: offerId
                }
            ]
        }
    ];

    return makeRPCPost(body);
};

export const getSamples = () => {
    const { config } = diContainer.get(serviceNames.config);
    const { perlgem } = config;
    const { brand_id, region_id } = perlgem || {};

    if (!brand_id) {
        return {
            samples: [],
            loyalty: {} as ILoyalty
        };
    }

    const queryParams = `brand=${brand_id}&region=${region_id}`;
    const url = `/rest/api/v1_0/offers/search/samples_qualified?${queryParams}`;

    return fetch(url, { method: 'GET', headers: getGlobalHeaders() })
        .then((res) => res.json())
        .then((res) => {
            const samples = parseRawSamples(Object.values(res));
            const loyalty = parseRawLoyalty(res.loyalty);

            return {
                samples,
                loyalty
            };
        });
};
